/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Testimonial_1_RoleInputs */

const en_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Club Player`)
};

const es_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugador de club`)
};

const de_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubspieler`)
};

const zh_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俱乐部球手`)
};

const ar_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لاعب نادي`)
};

const fr_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joueur de club`)
};

const vi_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfer câu lạc bộ`)
};

const sw_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mchezaji wa klabu`)
};

const th_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นักตีกอล์ฟสโมสร`)
};

const bs_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klubski igrač`)
};

const ja_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラブプレーヤー`)
};

const ko_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`클럽 플레이어`)
};

const pt_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogador de clube`)
};

const it_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giocatore di Club`)
};

const sv_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klubbspelare`)
};

const nl_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubspeler`)
};

const da_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klubspiller`)
};

const nb_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klubbspiller`)
};

const fi_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seurapelaaja`)
};

const pl_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gracz klubowy`)
};

const ru_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игрок гольф-клуба`)
};

const tr_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulüp oyuncusu`)
};

const hi_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्लब खिलाड़ी`)
};

const id_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain klub`)
};

const ms_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain kelab`)
};

const cs_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klubový hráč`)
};

const el_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παίκτης κλάμπ`)
};

const he_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שחקן מועדון`)
};

const af_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klubspeler`)
};

const hu_home_testimonial_1_role = /** @type {(inputs: Home_Testimonial_1_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klubjátékos`)
};

/**
* | output |
* | --- |
* | "Club Player" |
*
* @param {Home_Testimonial_1_RoleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_testimonial_1_role = /** @type {((inputs?: Home_Testimonial_1_RoleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Testimonial_1_RoleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_testimonial_1_role(inputs)
	if (locale === "de") return de_home_testimonial_1_role(inputs)
	if (locale === "zh") return zh_home_testimonial_1_role(inputs)
	if (locale === "ar") return ar_home_testimonial_1_role(inputs)
	if (locale === "fr") return fr_home_testimonial_1_role(inputs)
	if (locale === "vi") return vi_home_testimonial_1_role(inputs)
	if (locale === "sw") return sw_home_testimonial_1_role(inputs)
	if (locale === "th") return th_home_testimonial_1_role(inputs)
	if (locale === "bs") return bs_home_testimonial_1_role(inputs)
	if (locale === "ja") return ja_home_testimonial_1_role(inputs)
	if (locale === "ko") return ko_home_testimonial_1_role(inputs)
	if (locale === "pt") return pt_home_testimonial_1_role(inputs)
	if (locale === "it") return it_home_testimonial_1_role(inputs)
	if (locale === "sv") return sv_home_testimonial_1_role(inputs)
	if (locale === "nl") return nl_home_testimonial_1_role(inputs)
	if (locale === "da") return da_home_testimonial_1_role(inputs)
	if (locale === "nb") return nb_home_testimonial_1_role(inputs)
	if (locale === "fi") return fi_home_testimonial_1_role(inputs)
	if (locale === "pl") return pl_home_testimonial_1_role(inputs)
	if (locale === "ru") return ru_home_testimonial_1_role(inputs)
	if (locale === "tr") return tr_home_testimonial_1_role(inputs)
	if (locale === "hi") return hi_home_testimonial_1_role(inputs)
	if (locale === "id") return id_home_testimonial_1_role(inputs)
	if (locale === "ms") return ms_home_testimonial_1_role(inputs)
	if (locale === "cs") return cs_home_testimonial_1_role(inputs)
	if (locale === "el") return el_home_testimonial_1_role(inputs)
	if (locale === "he") return he_home_testimonial_1_role(inputs)
	if (locale === "af") return af_home_testimonial_1_role(inputs)
	if (locale === "hu") return hu_home_testimonial_1_role(inputs)
	return en_home_testimonial_1_role(inputs)
});